import {useCallback, useRef, useState} from "react";

/**
 * State with a ref updated in the same call - handlers called in a row (e.g. a double submit) read each other's updates before React renders.
 * Every update has to go through the returned setter, so the ref and the state never diverge.
 */
export const useRefState = <T>(initialState: T) => {
    const [state, setState] = useState(initialState);
    const ref = useRef(state);

    const set = useCallback((next: T) => {
        ref.current = next;
        setState(next);
    }, []);

    return [state, ref as {readonly current: T}, set] as const;
};
import {useCallback, useRef, useState} from "react";

/**
 * State with a ref updated in the same call - handlers called in a row (e.g. a double submit) read each other's updates before React renders.
 * Every update has to go through the returned setter, so the ref and the state never diverge.
 */
export const useRefState = <T>(initialState: T) => {
    const [state, setState] = useState(initialState);
    const ref = useRef(state);

    const set = useCallback((next: T) => {
        ref.current = next;
        setState(next);
    }, []);

    return [state, ref as {readonly current: T}, set] as const;
};
